// Mirrors backend `_haversine_m` + clock-in geofence (default radius 250 m).
export const DEFAULT_GEOFENCE_METERS = 250;

export const haversineMeters = (lat1, lng1, lat2, lng2) => {
  const R = 6371000;
  const rad = (d) => (d * Math.PI) / 180;
  const dp = rad(lat2 - lat1);
  const dl = rad(lng2 - lng1);
  const a = Math.sin(dp / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dl / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(a));
};

// Customer sites whose geofence contains `coords`, nearest first.
export const matchCustomerSites = (sites, coords) => {
  if (!coords) return [];
  return sites
    .filter((s) => !s.isLutromHQ && s.customerId && s.lat != null && s.lng != null)
    .map((s) => ({
      site: s,
      distance: Math.round(haversineMeters(Number(s.lat), Number(s.lng), coords.lat, coords.lng)),
      radius: Number(s.geofenceMeters) || DEFAULT_GEOFENCE_METERS,
    }))
    .filter((m) => m.distance <= m.radius)
    .sort((a, b) => a.distance - b.distance);
};
